import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { CallersComponent } from './callers.component';
import { CallersRoutingModule } from './callers.routing.module';
import { NgbdOrdersSortableHeader } from '../../services/caller/caller.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
	imports: [CommonModule, SharedModule, CallersRoutingModule, NgbModule],
	declarations: [CallersComponent, NgbdOrdersSortableHeader],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CallersModule {}
